import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

class API {
  constructor() {
    this.client = axios.create({
      baseURL: `${API_BASE_URL}/api`,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Request interceptor
    this.client.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('admin_token');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    // Response interceptor
    this.client.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          localStorage.removeItem('admin_token');
          window.location.href = '/admin/login';
        }
        return Promise.reject(error);
      }
    );
  }

  setToken(token) {
    if (token) {
      this.client.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete this.client.defaults.headers.common['Authorization'];
    }
  }

  // Auth
  async login(email, password) {
    return this.post('/auth/login', { email, password });
  }

  async getMe() {
    return this.get('/auth/me');
  }

  // Background check requests
  async submitBackgroundCheck(formData) {
    return this.client.post('/requests', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  async getBackgroundCheckRequests(search = '') {
    return this.get(`/requests${search ? `?search=${search}` : ''}`);
  }

  async getBackgroundCheckRequest(id) {
    return this.get(`/requests/${id}`);
  }

  async downloadResume(id) {
    return this.client.get(`/requests/${id}/download`, {
      responseType: 'blob',
    });
  }

  // Contact
  async submitContact(data) {
    return this.post('/contact', data);
  }

  // Generic methods
  async get(url, config = {}) {
    return this.client.get(url, config);
  }

  async post(url, data, config = {}) {
    return this.client.post(url, data, config);
  }

  async put(url, data, config = {}) {
    return this.client.put(url, data, config);
  }

  async delete(url, config = {}) {
    return this.client.delete(url, config);
  }
}

const api = new API();
export default api;
